import { render } from "./detectMsg.vue?vue&type=template&id=ed90ef32&scoped=true&ts=true"
import script from "./detectMsg.vue?vue&type=script&lang=ts"
export * from "./detectMsg.vue?vue&type=script&lang=ts"

import "./detectMsg.vue?vue&type=style&index=0&id=ed90ef32&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed90ef32"]])

export default __exports__